import React, { useEffect, useState, useRef, useCallback } from "react";
import Input from "../../components/controls/input/customInput/CustomInput";
import InputUnderline from "../../components/controls/input/InputUnderline";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
import Searchable from "../../components/controls/select/CustomSelect";
import {
  riskStatus,
  changeRequestTypes,
  riskProbability,
  riskImpact,
  calculatePageSize,
  UserSearchRefType,
} from "../../helpers/utils";
import service from "../../store/services/user.service";
import riskService from "../../store/services/risks.service";
import clientService from "../../store/services/clients.service";
import portfolioService from "../../store/services/portfolio.service";
import programService from "../../store/services/programs.service";
import projectService from "../../store/services/projects.service";
import searchService from "../../store/services/search.service";
import { CalendarIcon } from "../../modules/default-svg";
import ModalCheckbox from "../../components/controls/modalcheckbox/ModalCheckbox";
import { AddIconSvg } from "../../modules/default-svg";
import Button from "../../components/controls/button";
import _, { debounce } from "lodash";
import { apiCall } from "../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../store/services/URL";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import Table from "../../components/controls/tables/Table";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import { generalActions } from "../../store/actions";
import { useDispatch } from "react-redux";
import moment from "moment";
import "./Risk.scss";
import EntityFileUpload from "../../components/controls/fileUpload/EntityFileUpload";
import UserSelect from "../../components/userSelect/UserSelect";
import ModalCheckboxWarning from "../../components/controls/modalcheckbox/ModalCheckboxWarning";
import HealthStatusDropdown from "./statusDropdown";

const Risk = (props) => {
  const {
    portfolioID,
    projectID,
    programID,
    defaultProject,
    defaultProgram,
    defaultPortfolio,
    allRisks,
    pagination,
    pageLoading,
    loading,
    getRiskRequest,
    createRiskRequest,
    updateRiskRequest,
    deleteRiskRequest,
    error,
    overviewType,
    dashboardFilterSetProjectId,
    dashboardFilterSetProjectName,
    severityFilter,
    redirectionId,
    onRedirectionComplete,
  } = props;
  const permissions = localStorage.getItem("permissions");
  const prevClientId = useRef(null);
  const dispatch = useDispatch();
  const manualUpdate = useRef({
    client: false,
    portfolio: false,
    program: false,
  });
  const [data, setData] = useState([]);
  const [perPageItems] = useState(calculatePageSize());
  const [pageNum, setPageNum] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [ClientId, setClientId] = useState("");
  const [PortfolioId, setPortfolioId] = useState(portfolioID);
  const [ProgramId, setProgramId] = useState(programID);
  const [ProjectId, setProjectId] = useState(projectID);
  const [clientOptions, setClientOptions] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [name, setName] = useState("");
  const [isIssue, setIsIssue] = useState(false);
  const [isInWsr, setIsInWsr] = useState(false);
  const [trendingStatus, setTrendingStatus] = useState(null);
  const [dateIdentified, setDateIdentified] = useState(null);
  const [dateResolved, setDateResolved] = useState(null);
  const [dateImpact, setDateImpact] = useState(null);
  const [type, setType] = useState("");
  const [changeRequests, setChangeRequests] = useState([]);
  const [changeRequest, setChangeRequest] = useState(null);
  const [scopes, setScopes] = useState([]);
  const [scope, setScope] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [task, setTask] = useState(null);
  const [manager, setManager] = useState(null);
  // const [prime, setPrime] = useState("");
  const [status, setStatus] = useState(0);
  const [probability, setProbability] = useState(1);
  const [impact, setImpact] = useState(1);
  const [description, setDescription] = useState("");
  // const [contingencyPlan, setContingencyPlan] = useState("");
  const [mitigationPlan, setMitigationPlan] = useState("");
  const [isHeader, setIsHeader] = useState(true);
  const [parentType, setParentType] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
    projectId: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [tableSearch, setTableSearch] = useState(null);
  const [redirectionItem, setRedirectionItem] = useState(null);
  const [hasProcessedRedirection, setHasProcessedRedirection] = useState(false);

  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch = false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    payload.parent = parentType || "Risk";

    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }
    else if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }
    else if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }
    else if (severityFilter) {
      payload.Severity = severityFilter;
      payload.parent = "Severity";
    }
    else {
      payload.parent = "Risk";
    }

    if (projectID && severityFilter) {
      payload.Severity = severityFilter;
      payload.parent = "ProjectSeverity";
    }

    getRiskRequest(payload);
  };

  const searchClientHandler = (value) => {
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClientOptions(transformedArray);
      })
      .catch(() => {
        setClientOptions([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    const payload = { id: ClientId?.value, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (ClientId)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Risk";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (portfolioID) {
      queryParam = `?portfolioId=${portfolioID}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setProgramOptions(transformedArray);
      })
      .catch(() => {
        setProgramOptions([]);
      });
  };

  const searchProjectHandler = (value) => {
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Risk";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (portfolioID) {
      queryParam = `?portfolioId=${portfolioID}&searchTerm=${payload.searchText}`;
    }

    if (ProgramId) {
      queryParam = `?programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (programID) {
      queryParam = `?programId=${programID}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId && ProgramId) {
      queryParam = `?portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const setRequestType = (type) => {
    switch (type) {
      case "Scope":
        return 0;
      case "Schedule":
        return 1;
      case "Budget":
        return 2;
      case "Quality":
        return 3;
      case "Resource":
        return 4;
      default:
        return 0;
    }
  };

  const setRiskStatus = (type) => {
    switch (type) {
      case "Identified":
        return 0;
      case "Opened":
        return 1;
      case "Monitoring":
        return 2;
      case "Escalated":
        return 3;
      case "Impacted":
        return 4;
      case "Closed":
        return 5;
      default:
        return 0;
    }
  };

  const getRequestType = (type) => {
    switch (type) {
      case 0:
        return "Scope";
      case 1:
        return "Schedule";
      case 2:
        return "Budget";
      case 3:
        return "Quality";
      case 4:
        return "Resource";
      default:
        return "Scope";
    }
  };

  const getRiskStatus = (type) => {
    switch (type) {
      case 0:
        return "Identified";
      case 1:
        return "Opened";
      case 2:
        return "Monitoring";
      case 3:
        return "Escalated";
      case 4:
        return "Impacted";
      case 5:
        return "Closed";
      default:
        return "Identified";
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems, severityFilter]);

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);
    fetchData(pagination.TotalPages ?? 1, perPageItems > 10 ? perPageItems - 5 : perPageItems - 3);
  }, []);

  useEffect(() => {
    if (allRisks && allRisks.length > 0) {
      if (isCreateNewRow) {
        setData(
          allRisks.sort((a, b) => {
            return b.isFlagged - a.isFlagged;
          })
        );
        setIsCreateNewRow(false);
      } else {
        if (pageNum === 1) {
          setData(
            allRisks
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => {
                return b.isFlagged - a.isFlagged;
              })
          );
        } else {
          setData((prevData) => {
            const newMap = new Map(allRisks.map((item) => [item.id, item]));

            const updatedPrevData = prevData.map((item) =>
              newMap.has(item.id) ? newMap.get(item.id) : item
            );

            const prevDataIds = new Set(prevData.map((item) => item.id));
            const newItems = allRisks.filter(
              (shift) => !prevDataIds.has(shift.id)
            );

            return [...updatedPrevData, ...newItems]
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => b.isFlagged - a.isFlagged);
          });
        }
      }
    } else if (allRisks && allRisks.length === 0 && pageNum === 1) {
      setData([]);
    }
  }, [allRisks, deleteId, pageNum, isCreateNewRow]);

  const handleCreate = () => {
    setIsCreate(true);
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsEdit(false);
    setProjectId();
  };

  useEffect(() => {
    if (error !== "") {
      error &&
        Object.keys(error).forEach((key) => {
          if (key === "Name") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              name: error[key][0],
            }));
          }
        });
    } else {
      setFormErrors({});
    }
  }, [error]);

  const handleInputChange = (value, name) => {
    if (name === "name") {
      setName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  const handleSave = () => {
    const errors = {};
    if (!name) errors["name"] = `The Name field is required.`;
    if (!projectID) {
      if (!ProjectId) errors["projectId"] = `The Project field is required.`;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      ProjectId: projectID ? projectID : ProjectId?.value,
      Name: name,
      isIssue: isIssue,
      DateIdentified: dateIdentified ?? moment().format("YYYY-MM-DD"),
      DateImpact: dateImpact,
      DateResolved: dateResolved,
      Type: setRequestType(type),
      ChangeRequestId: changeRequest && changeRequest.value,
      ScopeId: scope && scope.value,
      TaskId: task && task.value,
      OwnerId: manager?.id,
      Status: setRiskStatus(status),
      Probability: probability,
      Impact: impact,
      Description: description,
      mitigationPlan: mitigationPlan ?? "",
      isInWsr: isInWsr,
      trendingStatus: trendingStatus ?? 0,
      // Prime: prime,
      // ContingencyPlan: contingencyPlan,
    };
    if (Object.keys(selectedRow).length > 0) {
      if (projectID) {
        updateRiskRequest({
          id: projectID,
          parentID: projectID,
          parent: "Project",
          payload: { rId: selectedRow.id, payload },
        });
        return;
      }
      if (programID) {
        updateRiskRequest({
          id: projectID,
          parentID: programID,
          parent: "Program",
          payload: { rId: selectedRow.id, payload },
        });
        return;
      }
      if (portfolioID) {
        updateRiskRequest({
          id: portfolioID,
          parentID: portfolioID,
          parent: "Portfolio",
          payload: { rId: selectedRow.id, payload },
        });
        return;
      }

      updateRiskRequest({
        id: projectID,
        parentID: projectID,
        parent: "Risk",
        payload: { rId: selectedRow.id, payload },
      });
    } else {
      if (projectID) {
        createRiskRequest({
          id: projectID,
          parentID: projectID,
          parent: "Project",
          payload,
          perPageItems,
        });
        return;
      }
      if (programID) {
        createRiskRequest({
          id: projectID,
          parentID: programID,
          parent: "Program",
          payload,
          perPageItems,
        });
        return;
      }
      if (portfolioID) {
        createRiskRequest({
          id: portfolioID,
          parentID: portfolioID,
          parent: "Portfolio",
          payload,
          perPageItems,
        });
        return;
      }

      createRiskRequest({
        id: projectID,
        parent: "Risk",
        payload,
        perPageItems,
      });
    }
  };

  const fetchRiskData = async () => {
    setIsLoading(true);
    riskService
      .getRiskDetailsRequest({ id: selectedRow.id })
      .then((riskData) => {
        setName(riskData.name);
        setIsIssue(riskData.isIssue);
        setDateIdentified(riskData.dateIdentified);
        setDateResolved(riskData.dateResolved);
        setDateImpact(riskData.dateImpact);
        setType(getRequestType(riskData.type));
        setIsInWsr(riskData.isInWsr);
        setTrendingStatus(riskData.trendingStatus);
        if (riskData.changeRequest) {
          const changeRequestArr = {
            value: riskData.changeRequest.id,
            label: riskData.changeRequest.name,
          };
          setChangeRequest(changeRequestArr);
        } else {
          setChangeRequest(null);
        }
        setManager(riskData.owner);
        // setPrime(riskData.prime ? riskData.prime : "");
        setStatus(getRiskStatus(riskData.status));
        setProbability(riskData.probability);
        setImpact(riskData.impact);
        setDescription(riskData.description);
        // setContingencyPlan(riskData.contingencyPlan);
        setMitigationPlan(riskData.mitigationPlan);
        riskData.client
          ? setClientId({
            label: riskData.client.name,
            value: riskData.client.id,
          })
          : setClientId("");
        riskData.portfolio
          ? setPortfolioId({
            label: riskData.portfolio.name,
            value: riskData.portfolio.id,
          })
          : setPortfolioId("");
        riskData.program
          ? setProgramId({
            label: riskData.program.name,
            value: riskData.program.id,
          })
          : setProgramId("");
        riskData.project
          ? setProjectId({
            label: riskData.project.name,
            value: riskData.project.id,
          })
          : setProjectId("");
        setScope(riskData.scope ? { label: riskData.scope.name, value: riskData.scope.id } : null);
        setTask(riskData.task ? { label: riskData.task.name, value: riskData.task.id } : null);
        setAttachments(riskData.attachments || []);
        setIsLoading(false);
      })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title:
              "Something went wrong fetching data. Please try again later.",
            type: "error",
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (Object.keys(selectedRow).length > 0) {
      setIsEdit(true);
      fetchRiskData();
    } else {
      setClientId("");
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      setName("");
      setIsIssue(false);
      setIsInWsr(false);
      setTrendingStatus(null);
      setDateIdentified(null);
      setDateResolved(null);
      setDateImpact(null);
      setType("");
      setChangeRequest(null);
      // setPrime("");
      setStatus(0);
      setProbability(1);
      setImpact(1);
      setDescription("");
      // setContingencyPlan("");
      setMitigationPlan("");
      setManager(null);
      setChangeRequests([]);
      setScopes([]);
      setScope(null);
      setTasks([]);
      setTask(null);
      setFormErrors({});
      setAttachments([]);
    }
  }, [selectedRow, isEdit]);

  const handleDelete = (selectedRow) => {
    // const id = JSON.parse(localStorage.getItem("selectedRow")).id;
    const id = selectedRow.id;
    if (projectID) {
      deleteRiskRequest({ sId: id, parentID: projectID, parent: "Project" });
      return;
    }
    if (programID) {
      deleteRiskRequest({ sId: id, parentID: programID, parent: "Program" });
      return;
    }
    if (portfolioID) {
      deleteRiskRequest({
        sId: id,
        parentID: portfolioID,
        parent: "Portfolio",
      });
      return;
    }

    deleteRiskRequest({ sId: id, parent: "Risk" });
    setDeletedId(id);
    // localStorage.removeItem("selectedRow");
  };

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  const changRequestSearchdebounced = useRef(
    debounce((value, params) => searchChangRequestHandler(value, params), 500)
  );

  const changRequestSearch = useCallback((value, params) => {
    changRequestSearchdebounced.current(value, params);
  }, []);

  const searchChangRequestHandler = (value, params) => {
    if (!params.projectId) {
      setChangeRequests([]);
      return;
    }
    searchService
      .ChangeRequests(value, params)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setChangeRequests(transformedArray);
      })
      .catch(() => {
        setChangeRequests([]);
      });
  };

  const scopeSearchdebounced = useRef(
    debounce((value, params) => searchScopeHandler(value, params), 500)
  );

  const scopeSearch = useCallback((value, params) => {
    scopeSearchdebounced.current(value, params);
  }, []);

  const searchScopeHandler = (value, params) => {
    if (!params.projectId) {
      setScopes([]);
      return;
    }
    searchService
      .Scopes(value, params)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setScopes(transformedArray);
      })
      .catch(() => {
        setScopes([]);
      });
  };

  const taskSearchdebounced = useRef(
    debounce((value, params) => searchTaskHandler(value, params), 500)
  );

  const taskSearch = useCallback((value, params) => {
    taskSearchdebounced.current(value, params);
  }, []);

  const searchTaskHandler = (value, params) => {
    if (!params.projectId && !params.scopeId) {
      setTasks([]);
      return;
    }
    searchService
      .Tasks(value, params)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setTasks(transformedArray);
      })
      .catch(() => {
        setTasks([]);
      });
  };

  useEffect(() => {
    if (projectID) {
      setParentType("Project");
      setIsHeader(false);
    }
    if (programID) {
      setParentType("Program");
      setIsHeader(false);
    }
    if (portfolioID) {
      setParentType("Portfolio");
      setIsHeader(false);
    }
    if (severityFilter) {
      setParentType("Severity");
      setIsHeader(false);
    }
  }, [projectID, programID, portfolioID, severityFilter]);

  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId, name]);

  const formBody = () => {
    return (
      <>
        <div className="d-flex  gap-2 align-items-end">
          <div className="col-9">
            <InputUnderline
              placeholder="Add risk title "
              value={name}
              error={formErrors.name}
              handleChange={(value) => handleInputChange(value, "name")}
              isRequired
              loading={isLoading}
            />
          </div>
          <div className="col-3">
            <HealthStatusDropdown
              tooltipText="Risk Trending Status"
              status={trendingStatus}
              onChange={setTrendingStatus}
              loading={isLoading}
            />
          </div>
        </div>

        <div className="flex col-10 gap-3 mt-3 mb-3">
          <ModalCheckboxWarning
            label={isIssue ? "Issue" : "Mark as Issue"}
            checked={isIssue}
            setChecked={setIsIssue}
            loading={isLoading}
          />
          <ModalCheckbox
            label={isInWsr ? "In WSR" : "Include in WSR"}
            checked={isInWsr}
            setChecked={setIsInWsr}
            loading={isLoading}
          />
        </div>
        <div className="d-flex">
          {parentType !== "Client" &&
            overviewType !== "Portfolio" &&
            overviewType !== "Program" &&
            overviewType !== "Project" && (
              <div className="w-50">
                <Searchable
                  label="Client"
                  SelectText="client"
                  selectWd="me-3"
                  searchText={searchClientHandler}
                  options={clientOptions}
                  defaultVal={ClientId}
                  onChange={(e) => {
                    setClientId(e);
                    setPortfolioId("");
                    setProgramId("");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
          {overviewType !== "Portfolio" &&
            overviewType !== "Program" &&
            overviewType !== "Project" && (
              <div className="w-50">
                <Searchable
                  label="Portfolio"
                  SelectText="portfolio"
                  selectWd="me-3"
                  searchText={searchPortfolioHandler}
                  options={portfolioOptions}
                  defaultVal={PortfolioId}
                  onChange={(e) => {
                    setPortfolioId(e);
                    setProgramId("");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
        </div>
        <div className="d-flex mt-3 mb-3">
          {overviewType !== "Program" && overviewType !== "Project" && (
            <div className="w-50">
              <Searchable
                label="Program"
                SelectText="program"
                selectWd="me-3"
                searchText={searchProgramHandler}
                options={programOptions}
                defaultVal={ProgramId}
                onChange={(e) => {
                  setProgramId(e);
                  setProjectId("");
                }}
                loading={isLoading}
              />
            </div>
          )}
          {overviewType !== "Project" && (
            <div className="w-50">
              <Searchable
                label="Project"
                SelectText="project"
                selectWd="me-3"
                searchText={searchProjectHandler}
                options={projectOptions}
                defaultVal={ProjectId}
                onChange={(e) => {
                  setProjectId(e);
                  setManager(null);
                }}
                errorMessage={formErrors.projectId}
                isRequired
                loading={isLoading}
              />
            </div>
          )}
          <div className="w-50">
            <UserSelect
              refType={UserSearchRefType.Project}
              refId={projectID ? projectID : ProjectId?.value}
              label="Prime"
              buttonLabel={"Select Prime"}
              value={manager}
              onChange={setManager}
              loading={isLoading}
              disabled={!projectID && !ProjectId}
            />
          </div>
        </div>
        {(ProjectId || projectID) && (
          <>
            <label class="Input_label">Affected Workstream</label>
            <div className="row mt-3 mb-5 gx-3 risk-affected-workstream">
              <div className="col-6">
                <Searchable
                  label="Scope / Milestone "
                  searchText={(e) =>
                    scopeSearch(e, {
                      projectId: (ProjectId && ProjectId.value) || projectID,
                    })
                  }
                  SelectText="scope"
                  options={scopes}
                  defaultVal={scope}
                  onChange={(e) => {
                    setScope(e);
                    setTask(null);
                  }}
                  loading={isLoading}
                />
              </div>

              <div className="col-6">
                <Searchable
                  label="Task"
                  searchText={(e) =>
                    taskSearch(e, {
                      projectId: (ProjectId && ProjectId.value) || projectID,
                      scopeId: scope && scope.value,
                    })
                  }
                  SelectText="task"
                  options={tasks}
                  defaultVal={task}
                  onChange={setTask}
                  loading={isLoading}
                />
              </div>
            </div>
          </>
        )}
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={dateIdentified ? dateIdentified : ""}
              type="date"
              handleChange={setDateIdentified}
              label="Date Identified"
              placeholder="Enter Date"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={dateImpact ? dateImpact : ""}
              type="date"
              handleChange={setDateImpact}
              label="Date Of Impact"
              placeholder="Enter Date"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={dateResolved ? dateResolved : ""}
              type="date"
              handleChange={setDateResolved}
              label="Date Resolved"
              placeholder="Enter Date"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-4">
            <DropDown
              label="Category"
              options={changeRequestTypes}
              defaultVal={type}
              onChange={setType}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Searchable
              label="Change Request"
              searchText={(e) =>
                changRequestSearch(e, {
                  projectId: (ProjectId && ProjectId.value) || projectID,
                })
              }
              SelectText="change request"
              options={changeRequests}
              defaultVal={changeRequest}
              onChange={setChangeRequest}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <DropDown
              label="Status"
              options={riskStatus}
              defaultVal={dateResolved ? "Closed" : status}
              onChange={setStatus}
              loading={isLoading}
              disabled={dateResolved}
            />
          </div>
        </div>
        <div className="row align-items-center mb-3 gx-3">
          {/* <div className="col-4">
            <Input
              value={`${prime}`}
              type="text"
              handleChange={setPrime}
              label="Prime"
              placeholder="Enter Prime"
              loading={isLoading}
            />
          </div> */}

          <div className="col-4">
            <DropDown
              label="Probability"
              options={riskProbability}
              defaultVal={probability}
              onChange={setProbability}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <DropDown
              label="Impact"
              options={riskImpact}
              defaultVal={impact}
              onChange={setImpact}
              loading={isLoading}
            />
          </div>
        </div>
        {/* <div className="row align-items-center mb-3 gx-3">
          
        </div> */}
        <div className="mb-3">
          <RichTextEditor
            label="Description"
            content={description}
            onChange={setDescription}
            loading={isLoading}
          />
        </div>
        <div className="mb-3">
          <RichTextEditor
            label="Mitigation Plan"
            content={mitigationPlan}
            onChange={setMitigationPlan}
            loading={isLoading}
          />
        </div>
        <EntityFileUpload
          entityId={selectedRow.id}
          entityType="Risk"
          attachments={attachments}
          onAttachmentsChange={() => {
            if (selectedRow.id) {
              riskService.getRiskDetailsRequest({ id: selectedRow.id })
                .then((riskData) => {
                  setAttachments(riskData.attachments);
                })
                .catch((error) => {
                  console.error("Error fetching risk data:", error);
                });
            }
          }}
          disabled={isLoading || !selectedRow.id}
        />
      </>
    );
  };

  useEffect(() => {
    if (defaultProject && defaultProject.hasOwnProperty("name")) {
      setProjectId({
        label: defaultProject.name,
        value: defaultProject.id,
      });
    }
  }, [defaultProject]);

  useEffect(() => {
    if (defaultProgram && defaultProgram.hasOwnProperty("name")) {
      setProgramId({
        label: defaultProgram.name,
        value: defaultProgram.id,
      });
    }
  }, [defaultProgram]);

  useEffect(() => {
    if (defaultPortfolio && defaultPortfolio.hasOwnProperty("name")) {
      setPortfolioId({
        label: defaultPortfolio.name,
        value: defaultPortfolio.id,
      });
    }
  }, [defaultPortfolio]);

  useEffect(() => {
    if (ProjectId && !manualUpdate.current.program) {
      if (!ClientId && !PortfolioId && !ProgramId && !projectID) {
        projectService
          .getProjectDetailsRequest({ id: ProjectId.value })
          .then((projectData) => {
            // Mark the next updates as manual to prevent cascading effects
            manualUpdate.current.program = true;
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            // Update the state of the parent fields
            projectData.client
              ? setClientId({
                label: projectData.client.name,
                value: projectData.client.id,
              })
              : setClientId("");
            projectData.portfolio
              ? setPortfolioId({
                label: projectData.portfolio.name,
                value: projectData.portfolio.id,
              })
              : setPortfolioId("");
            projectData.program
              ? setProgramId({
                label: projectData.program.name,
                value: projectData.program.id,
              })
              : setProgramId("");
          })
          .catch((error) =>
            console.error("Error fetching project data:", error)
          );
      }
    }
  }, [ProjectId]);

  useEffect(() => {
    if (!ProgramId) {
      setProjectId("");
    }
    if (ProgramId && !manualUpdate.current.portfolio) {
      if (!ClientId && !PortfolioId) {
        programService
          .fetchProgramDataRequest({ id: ProgramId.value })
          .then((data) => {
            // Mark the next updates as manual to prevent cascading effects
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            // Update the state of the parent fields
            data.client
              ? setClientId({ label: data.client.name, value: data.client.id })
              : setClientId("");
            data.portfolio
              ? setPortfolioId({
                label: data.portfolio.name,
                value: data.portfolio.id,
              })
              : setPortfolioId("");
            setProjectId(""); // Clear ProjectId when ProgramId changes
          })
          .catch((error) =>
            console.error("Error fetching program data:", error)
          );
      } else {
        if (!isEdit) {
          setProjectId("");
        }
      }
    }
  }, [ProgramId]);

  useEffect(() => {
    if (!PortfolioId) {
      setProgramId("");
      setProjectId("");
    }
    if (PortfolioId && !manualUpdate.current.client) {
      if (!ClientId) {
        portfolioService
          .getPortfolioDetails({ id: PortfolioId })
          .then((portfolioData) => {
            manualUpdate.current.client = true;
            portfolioData.client
              ? setClientId({
                label: portfolioData.client.name,
                value: portfolioData.client.id,
              })
              : setClientId("");
            setProgramId("");
            setProjectId("");
          })
          .catch((error) =>
            console.error("Error fetching portfolio data:", error)
          );
      } else {
        if (!isEdit) {
          setProgramId("");
          setProjectId("");
        }
      }
    }
  }, [PortfolioId]);

  useEffect(() => {
    if (!ClientId) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
    }
    if (ClientId) {
      prevClientId.current = ClientId.value;
    }
    // if (ClientId && prevClientId.current === null) {
    //   prevClientId.current = ClientId.value;
    // }
    if (ClientId && prevClientId.current !== ClientId.value) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      prevClientId.current = ClientId.value;
    }
    manualUpdate.current.client = false;
    manualUpdate.current.portfolio = false;
    manualUpdate.current.program = false;
  }, [ClientId]);

  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);
  };

  useEffect(() => {
    if (!hasProcessedRedirection && redirectionId) {
      setHasProcessedRedirection(true);
      setRedirectionItem({ id: redirectionId });

      if (onRedirectionComplete) {
        onRedirectionComplete();
      }
    }
  }, [redirectionId]);

  return (
    <ColumnConfigProvider
      tableName={parentType ? `${parentType}-Risk` : "Risk"}
    >
      <div className="listingScreen position-relative">
        {isHeader && overviewType !== "Dashboard" && (
          <div className="db_Subheader d-flex justify-content-between align-items-center mb-4">
            <h4>Risks / Issues</h4>
            {permissions?.includes("Risk.Create") && (
              <Button
                btnClass="d_btn d_btn_primary"
                icon={<AddIconSvg />}
                label="Add Risk"
                clickHandler={handleCreate}
              />
            )}
          </div>
        )}

        <Table
          isHeader={isHeader}
          parentType={parentType}
          type="Risk"
          rows={data || []}
          body={formBody()}
          searchHandler={handleSearch}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          setPageNum={setPageNum}
          perPageItems={perPageItems}
          setIsCreate={setIsCreate}
          loading={pageLoading}
          modalLoading={loading}
          isCreate={isCreate}
          pagination={pagination}
          handleSave={() => handleSave()}
          handleDelete={(selectedRow) => handleDelete(selectedRow)}
          handleCancel={() => handleCancel()}
          setIsEdit={setIsEdit}
          setSelectedRow={setSelectedRow}
          portfolioId={portfolioID}
          overviewType={overviewType}
          programId={programID}
          projectId={projectID}
          dashboardFilterSetId={dashboardFilterSetProjectId}
          dashboardFilterSetName={dashboardFilterSetProjectName}
          handleAddRow={handleAddRow}
          handleCancelAddRow={handleCancelAddRow}
          setData={setData}
          triggerSearch={handleSearchTrigger}
          forceShowEditModal={redirectionItem}
        />
      </div>
    </ColumnConfigProvider>
  );
};

export default Risk;
